import {
  AloftArea,
  CraftsmanCostProps,
  ORDER_FEATURES,
  getCraftsmanCost,
  isUndefined,
} from '@aloft/toolkit-shared';

import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';
import { selectPropertyIdentificationEntities } from '../propertyDataSelectors/propertyIdentificationSelectors.ts';
import { createFeatureCostSelectors } from '../utils/createFeatureCostSelectors.ts';
import { selectCostProps } from './selectCostProps.ts';

const calculateBarnCost = (
  costProps: CraftsmanCostProps,
  improvements: ReturnType<typeof selectImprovementsEntities>,
  propertyIdentification: ReturnType<typeof selectPropertyIdentificationEntities>,
  id: string,
) => {
  const improvementsForTransaction = improvements[id];
  const identification = propertyIdentification[id];

  if (!improvementsForTransaction || !identification) {
    return undefined;
  }

  const { barn } = improvementsForTransaction;

  const zipCode = identification.address.PostalCode;

  if (!barn || !barn.area || isUndefined(barn.quality) || isUndefined(zipCode)) {
    return undefined;
  }

  const calculator = getCraftsmanCost(costProps);

  return calculator.getBarnCost({
    hasFeature: ORDER_FEATURES.barn.hasFeature(improvementsForTransaction),
    sqft: AloftArea.schema.parse(barn.area),
    quality: barn.quality,
    zipCode,
  });
};

export const { selectBarnCost, selectZipOnlyBarnCost, selectBarnCosts, selectBarnCostDisplay } =
  createFeatureCostSelectors({
    calculate: calculateBarnCost,
    inputSelectors: [
      selectCostProps,
      selectImprovementsEntities,
      selectPropertyIdentificationEntities,
    ],
    names: {
      cost: 'selectBarnCost',
      zipOnly: 'selectZipOnlyBarnCost',
      costs: 'selectBarnCosts',
      display: 'selectBarnCostDisplay',
    },
  });
